export const environment = {
  production: false,
  name: 'staging',
  encryptionKey: 'Tjcjavr2TPMiixGSUrbqySC7qagyY0IWlIrev4RZnvsEJPBjFoRsDpBmuD2WxxKL',
  encryptionIv: 'sbWIbGr25EOItOzCz2mlliu7ZEgRaPu7klKEEFELJjQ=',
  authentication: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/authentication/v1/'
  },
  dashboard: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/dashboard/v1/'
  },
  invoice: {
    bypassUrl: 'https://purchase-api.petpooja.com',
    bypassPath: '/api/web/invoice/v1/',
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/invoice/v1/'
  },
  payment: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/payment/v1/',
    bypassUrl: 'https://purchase-api.petpooja.com',
    bypassPath: '/api/web/payment/v1/',
  },
  metadata: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/metadata/v1/'
  },
  pushtopetpooja: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/push-to-petpooja/v1/'
  },
   tally: {
    url: 'https://purchase-api.petpooja.com',
    path: '/api/web/tally/v1/'
  }
};